import CONSTANTS from '@/constants'
import { IAuthState } from '@/@types'

const state: IAuthState = {
  userProfile: {
    account_id: '',
    mfa_required: null,
    avatar: '',
    preferred_phone_number: '',
    mfa_method: '',
  },
  isAuthenticated: false,
  isAdmin: false,
  isContentCreator: false,
  isBusinessManager: false,
  isAuthLoading: false,
  isTwoFactorRequired: false,
  isGoogleAuthenticatorMFA: false,
  hasPlaylists: false,
  redirectUrl: '',
  sampleAvatars: [],
  currentAvatar: require('@/assets/images/avatars/default.png'),
  subscriptionStatus: '',
  profilePreferences: {
    passes: [] || undefined,
  },
  authProviders: CONSTANTS.AUTH_PROVIDERS,
  onboardingSurvey: {},
  available_passes: [],
  labExperienceUserAccess: {
    available_time: 0,
    consumed_time: 0,
    purchased_time: 0,
    state: '',
  },
}

export default state
